import Popup from "./Popup";

export default function PopupClipLimitExceed({
  isOpen,
  onPrimaryClick,
  onClose,
}: {
  isOpen: boolean;
  onPrimaryClick: () => void;
  onClose: () => void;
}) {
  return (
    <Popup
      heading={
        <div>
          クーポンの選択数が
          <br />
          上限を超えています
        </div>
      }
      subheading="同時に利用できるクーポンは５つまでです。選び直してから、もう一度お試しください。"
      primaryButtonLabel="戻る"
      onPrimaryClick={onPrimaryClick}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}
